module.exports = __webpack_public_path__ + "static/media/information-line.6eee51fd.svg";